import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';

export default class extends Controller {
  static values = { commentId: Number };
  static targets = ['counter'];

  connect() {
    this.element.addEventListener('ajax:success', this.update.bind(this));
    this.updateBulbVisibility();
  }

  update(event) {
    const [data] = event.detail;

    if (data.endorsed_by_user_ids.includes(CurrentUser.id())) {
      CurrentUser.addEndorsedComment(this.commentIdValue);
    } else {
      CurrentUser.removeEndorsedComment(this.commentIdValue);
    }
    this.counterTarget.innerText = data.endorsed_by_user_ids.length;
    this.updateBulbVisibility();
  }

  updateBulbVisibility() {
    this.element.classList.toggle(
      'is-active',
      CurrentUser.endorsedComments().includes(this.commentIdValue)
    );
  }
}
